import SmartToyIcon from '@mui/icons-material/SmartToy';


export const stringToColor = (string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

export const stringAvatar = (name) => {
    name = name.replace('  ', ' ');
    const nameParts = name.split(' ');
    let initials = '';
    if (nameParts.length > 0) {
        if (nameParts[0].length > 0) {
            initials += nameParts[0][0].toUpperCase();
        }
        if (nameParts.length > 1 && nameParts[1].length > 0) {
            initials += nameParts[1][0].toUpperCase();
        }
    }
    if (initials === "SN" || initials === "NN") {
        initials = <SmartToyIcon/>
    }
    return {
        sx: {
            bgcolor: stringToColor(name),
            height: 30,
            width: 30,
            fontSize: '1em'
        },
        children: initials,
    };
}

export const handleNameStringAvatar = (name, lastname) => {
    name = name ? name : 'S N';

    if (lastname) {
        return `${name} ${lastname}`
    }

    let length_name = name.split(' ').length

    if (length_name > 1) {
        return name
    }
    name = name.length === 1 ? `${name.charAt(0)} ${name.charAt(0)}` : `${name.charAt(0)} ${name.charAt(1)}`

    return name
}